import { Dialog } from "@minuthq/meatball-ui-react"
import { useFormik } from "formik"

import { TaskForm } from "src/components/TaskManagement/TaskForm"
import { TMaybeHome } from "src/data/homes/types/homeTypes"
import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { usePatchTask } from "src/data/taskManagement/taskManagementQueries"
import {
  TTask,
  TTaskPostBody,
} from "src/data/taskManagement/taskManagementTypes"
import { useTranslate } from "src/i18n/useTranslate"

const EDIT_TASK_FORM_ID = "edit_task_form"

export function EditTaskDialog({
  task,
  homes,
  members,
  onClose,
}: {
  task: TTask
  homes: TMaybeHome[]
  members: {
    id: string
    name: string
  }[]
  onClose: () => void
}) {
  const { tPlaceholder, t, langKeys } = useTranslate()
  const { orgId } = useOrganization()

  const patchTask = usePatchTask()

  const form = useFormik<TTaskPostBody>({
    initialValues: {
      title: task.title,
      home_id: task.home_id,
      category: task.category,
      description: task.description,
      status: task.status,
      assigned_to: {
        assignee_id: task.assigned_to?.assignee_id ?? "",
        type: "member",
      },
      time_window: task.time_window,
    },
    onSubmit: (values) => {
      patchTask.mutate(
        {
          path: { organization_id: orgId, task_id: task.task_id },
          body: { ...values },
        },
        {
          onSuccess: onClose,
        }
      )
    },
  })

  return (
    <Dialog
      open={true}
      onClose={onClose}
      title={tPlaceholder("Edit task")}
      confirmLabel={tPlaceholder("Save")}
      formId={EDIT_TASK_FORM_ID}
      closeLabel={tPlaceholder("Cancel")}
      error={patchTask.isError && t(langKeys.failed_general_error_title)}
      loading={patchTask.isLoading}
    >
      <form id={EDIT_TASK_FORM_ID} onSubmit={form.handleSubmit}>
        <TaskForm form={form} homes={homes} members={members} mode="edit" />
      </form>
    </Dialog>
  )
}
